import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import getCommercial from "../../../util/getCommercial";
import { Row, Col } from "react-bootstrap";
import MenuGroup from "../../../components/MenuGroup";

export default function GroupLayout() {
  const [commercialId, setcommercialId] = useState(null);
  useEffect(() => {
    let _pathname;
    if (window.location.pathname.includes("/groups/") && !window.location.pathname.includes("/costs/")) {
      _pathname = window.location.pathname.split("/");
      setcommercialId(parseInt(_pathname[2]));
    }
    // Run once on mount: `window.location` is a global, not reactive state, so listing it as a
    // dependency wouldn't actually trigger re-runs on navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [reload, setreload] = useState(false);
  const [commercial, setcommercial] = useState(null);

  useEffect(() => {
    if (commercialId) {
      setcommercial(null);
      getCommercial(commercialId).then(response => {
        setcommercial(response);
      });
    }
  }, [reload, commercialId]);

  return (
    <>
      <Row>
        <Col>
          <Outlet context={{ commercial, reload, setreload }} />
        </Col>
        <Col sm={3} className="-hide-on-print">
          <MenuGroup commercial={commercial} reload={reload} setreload={setreload} />
        </Col>
      </Row>
    </>
  );
}
